import React from 'react';
import { TutorialItem } from '@/api/tutorial/response';
import { Modal } from '@/ui/modals';
import { Editor } from '@/ui/Editor';
import { Button } from '@/ui/Button';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/ui/Icon';
import { TFunction } from 'i18next';
import PopupNotification from '@/domain/core/PopupNotification';

interface IProps {
	tutorial: TutorialItem;
	isViewModalOpen: boolean;
	setViewModalOpen: (value: boolean) => void;
}

const handleCopy = (link: string, t: TFunction) => {
	if (navigator.clipboard) {
		navigator.clipboard.writeText(link);
	} else {
		const input = document.createElement('textarea');
		input.value = link;
		document.body.appendChild(input);
		input.select();
		document.execCommand('copy');
		document.body.removeChild(input);
	}
	PopupNotification.emitter('success', t('selections.linkCopied'));
};

const LinkComponent: React.FC<{tutorial: TutorialItem, t: TFunction}> = ({ tutorial, t }) => {
	const link = React.useMemo(() => {
		return `${process.env.NEXT_PUBLIC_FRONT_HOST}/tutorial?viewTutorialId=${tutorial.id}`;
	}, [tutorial.id]);

	return (
		<div className="mb-[20px] text-sm cursor-pointer" onClick={() => handleCopy(link, t)}>
			{t('tutorial.link')}: <span className='text-brand-blue'>{link}</span>
			<Icon name="copy" className='ml-[5px] text-brand-blue'/>
		</div>
	);
}

export const TutorialDetailsModal: React.FC<IProps> = ({ tutorial, isViewModalOpen, setViewModalOpen }) => {
	const { t } = useTranslation();

	return (
		<Modal
			dialogContentProps={{className: 'max-w-[70%]'}}
			title={tutorial.name}
			open={isViewModalOpen}
			setOpen={setViewModalOpen}		
			closeButton={false}
			disableScrollArea={false}
			footer={
				<Button variant="default" onClick={() => setViewModalOpen(false)}>
					{t('buttons.close')}
				</Button>
			}
		>			
			<LinkComponent tutorial={tutorial} t={t}/>
			<Editor editable={false} value={tutorial.content ?? ''}/>
		</Modal>
	);
};
